import { useState } from 'react'
import Header from "../components/components-layout/Header";
import Container from "../components/components-layout/Container";

import Logo from './components-login/Logo.js'
import SeleccionOpcion from './recuperar-cuenta/SeleccionOpcion.js'
import SeleccionRecuperar from './recuperar-cuenta/SeleccionRecuperar.js'
import SeleccionUsuario from './recuperar-cuenta/SeleccionUsuario.js'
import IntroducirCodigo from './recuperar-cuenta/password/IntroducirCodigo.js'
import IntroducirCorreo from './recuperar-cuenta/password/introducirCorreo.js'
import UsuarioCuenta from './recuperar-cuenta/usuario/UsuarioCuenta.js'
import CarnetUsuario from './recuperar-cuenta/usuario/CarnetUsuario.js'

import { KeyIcon } from "@heroicons/react/24/outline";
import Footer from './components-layout/Footer';

const RecuperacionCuenta = () => {

    const [stepRecupera, setStepRecupera] = useState(false)
    const [stepUsuario, setUsuario] = useState(false)
    
    const [step1Recupera, setStep1Recupera] = useState(false)
    const [step2Recupera, setStep2Recupera] = useState(false)
    const [step3Recupera, setStep3Recupera] = useState(false)
    const [step4Recupera, setStep4Recupera] = useState(false)
    
    const [step1Usuario, setStep1Usuario] = useState(false)
    const [step2Usuario, setStep2Usuario] = useState(false)

    const [estadoEnvio, setEstadoEnvio]  = useState('')

    const [correoEnviado, setCorreoEnviado] = useState(false);
    const [codigoEnviado, setCodigoEnviado] = useState(false);

    const [dato, setDato] = useState('')

    const setContenido = (data = '', opcion = '') => {
        let opciones = {
            "usuarioStep1":() => {
                setDato(data)
                handleContinuar(opcion)
            },
            "contrasenaStep1":() => {
                setDato(data)
                handleContinuar(opcion)
            },
            "contrasenaStep2":() => { // codigo de verificacion
                setDato(data)
                handleContinuar(opcion)
            },
            "contrasenaStep3":() => { // codigo de verificacion
                //setDato(data)
                setStep4Recupera(true)
                handleContinuar(opcion)
            },
        }
        opciones[opcion]()
    }

    const handleAtras=(e)=>{
        let opciones = {
            "carnetUsuario":()=>{
                setStepRecupera(false)
                setStep1Usuario(false)
            },
            "usuarioFinal":()=>{
                setStep1Usuario(true)
                setStep2Usuario(false)
            },
            "passStep1":()=>{
                setStepRecupera(false)
                setStep1Recupera(false)
            },
            "passStep2": ()=>{
                setStep1Recupera(true)
                setStep2Recupera(false)
                setCorreoEnviado(false)
                setCodigoEnviado(false)
                setStep3Recupera(false)
                setEstadoEnvio('correoNoEnviado')
            },
            "passStep3": ()=>{
                //obligado a irse hasta la pantalla de correo para que
                setStep1Recupera(true)
                setStep2Recupera(false)
                setStep3Recupera(false)
                setEstadoEnvio('correoNoEnviado')
                setCorreoEnviado(false)
                setCodigoEnviado(false)
                setStep3Recupera(false)
            }
            
        }
        opciones[e.name]()
    }


    const handleContinuar = (opcion) => {

        let opciones = {
            "contrasena": () => {
                setStepRecupera(true)
                setStep1Recupera(true)
                setUsuario(false)
            },
              "contrasenaStep1":() => {
                  setStep1Recupera(false)
                  setStep2Recupera(true)
              },
                "contrasenaStep2":() => { // codigo de verificacion
                    setStep2Recupera(false)
                    setStep3Recupera(true)
                },
                  "contrasenaStep3":() => { // codigo de verificacion
                      setStep3Recupera(false)
                      setStep4Recupera(true)
                  },

            "usuario": () => {
                setStepRecupera(true)
                setStep1Usuario(true)
                setUsuario(true)
            },
              "usuarioStep1":() => {
                  setStep1Usuario(false)
                  setStep2Usuario(true)
              },
        }
        opciones[opcion]()
    }
    
    return (
        <Container height="h-full flex-col">
          <Header title="Recuperación de contraseña / Usuario" logo={KeyIcon} />
          <div
          className="mt-24"
          ></div>
          <div className='flex items-center justify-center h-[80%] w-full bg-secundarioMira bg-auto'>
              <div className="flex flex-col justify-center w-auto sm:w-96 h-auto lg:flex-row lg:w-full lg:max-w-4xl">
                  <div className='flex flex-col px-4 py-2 bg-primarioMira shadow-2xl rounded-2xl lg:rounded-2xl'>
                      <div
                      className=" w-full rounded-lg mb-2">
                          <Logo alt='icono imb-pc' src='./img/Logo-xl.png' />
                      </div>
                      
                      {!stepRecupera
                          ? 
                          <SeleccionOpcion
                              handleContinuar={handleContinuar}
                          />
                          : !stepUsuario
                              ? 
                              <>  
                                <SeleccionRecuperar setCorreoEnviado={setCorreoEnviado} setCodigoEnviado={setCodigoEnviado} codigoEnviado={codigoEnviado} correoEnviado={correoEnviado} handleContinuar={handleContinuar} setContenido={setContenido} mensajeycodigo={dato} step3Recupera={step3Recupera} setStep3Recupera={setStep3Recupera} step4Recupera={step4Recupera} estadoEnvio={estadoEnvio} handleAtras={handleAtras} datosRevisionCuenta={dato}
                                  children = {
                                   step1Recupera ? <IntroducirCorreo handleContinuar={handleContinuar} handleAtras={handleAtras}/> :
                                   step2Recupera ? <IntroducirCodigo handleContinuar={handleContinuar} handleAtras={handleAtras} mensajeycodigo={dato}/> : null}
                                />
                              </>
                              : 
                              <>
                                <SeleccionUsuario handleContinuar={handleContinuar} setContenido={setContenido}
                                  children = {
                                   step1Usuario ? <CarnetUsuario handleContinuar={handleContinuar} handleAtras={handleAtras}/> :
                                   step2Usuario ? <UsuarioCuenta handleContinuar={handleContinuar} handleAtras={handleAtras} familiaUsuario={dato}/> : null}
                                />
                              </>
                      }
                  </div>
              </div>
          </div>
        <div
        className="mt-24 bg-gray-700 py-10"
        >

        <Footer/>
        </div>
    </Container>
    )
}

export default RecuperacionCuenta